import styled from 'styled-components';

export const Layout = styled.div`
  display: grid;
  height: 100vh;
  grid-template-rows: 50px 1fr 3fr 1fr 1fr 2fr;
  grid-template-columns: 50px 2fr 2.7fr;
  grid-template-areas:
    'snav tbar tbar'
    'snav product lotNumber'
    'snav media askingBid'
    'snav media status'
    'snav media comments'
    'snav details details';
  grid-gap: 5px;
  overflow-y: scroll;
  & > div:not(:first-child) {
    border: 1px solid gray;
  }
  & .blockStatus {
    & h2 {
      font-size: min(2vw, 3em);
    }
  }
`;

export default Layout;
